import classNames from 'classnames'
import React from 'react'

const CustomizeOption = ({
  onClick,
  label,
  value,
  icon,
  disabled,
}) => {
  return (
    <div className="customize-option gap-2 p-4" onClick={onClick}>
      <div className={classNames('customize-option__label label-medium !font-medium gap-2 whitespace-nowrap', { 'text-tertiary': disabled })}>
        <i className={icon} />
        {label}
      </div>
      <div className={classNames('customize-option__value ms-auto label-medium !font-semibold text-primary italic', { 'text-tertiary': disabled })}>{value}</div>
    </div>
  )
}

export default CustomizeOption
